var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBenefitEvent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_06"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 423",
    cx: 45,
    cy: 45,
    r: 45,
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_8867_97188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M50.228 67.3575H25.2903C25.065 67.361 24.8412 67.32 24.6322 67.237C24.4232 67.1541 24.2332 67.0308 24.0735 66.8745C23.9138 66.7182 23.7876 66.5321 23.7024 66.3271C23.6172 66.1221 23.5746 65.9024 23.5773 65.6809V42.5557",
    stroke: "#5A5A5A",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M58.8848 42.5303V49.5257",
    stroke: "#5A5A5A",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M38.0854 42.5556H21.3404C21.1167 42.5557 20.8952 42.5119 20.6888 42.4271C20.4824 42.3422 20.2953 42.2178 20.1383 42.0612C19.9813 41.9045 19.8576 41.7188 19.7743 41.5147C19.6911 41.3107 19.6501 41.0924 19.6535 40.8726V34.1085C19.6535 33.6689 19.8313 33.2474 20.1476 32.9366C20.464 32.6258 20.893 32.4512 21.3404 32.4512H61.1401C61.5841 32.4562 62.0081 32.6331 62.3202 32.9433C62.6324 33.2536 62.8074 33.6723 62.8074 34.1085V40.8726C62.8108 41.0908 62.7704 41.3075 62.6884 41.5103C62.6064 41.7131 62.4844 41.898 62.3295 42.0543C62.1746 42.2107 61.9898 42.3355 61.7857 42.4215C61.5816 42.5075 61.3622 42.5531 61.1401 42.5556H44.4016",
    stroke: "#5A5A5A",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M38.0859 67.351V31.4298C38.0859 31.0223 38.1676 30.6189 38.3263 30.2425C38.485 29.866 38.7177 29.524 39.0109 29.2359C39.3042 28.9478 39.6523 28.7192 40.0355 28.5633C40.4186 28.4074 40.8293 28.3271 41.244 28.3271C41.6587 28.3271 42.0694 28.4074 42.4526 28.5633C42.8357 28.7192 43.1839 28.9478 43.4771 29.2359C43.7704 29.524 44.003 29.866 44.1617 30.2425C44.3204 30.6189 44.4021 31.0223 44.4021 31.4298V67.351",
    stroke: "#5A5A5A",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M56.5172 32.4518C60.7541 27.8974 58.0014 22.9062 53.6534 22.6428C49.0764 22.3923 45.9968 26.9145 44.0811 30.0621",
    stroke: "#5A5A5A",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M25.9567 32.4518C21.7197 27.8974 24.4724 22.9062 28.8074 22.6428C33.3843 22.3795 36.4705 26.9017 38.3863 30.0493",
    stroke: "#5A5A5A",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M67.5415 56.0459V66.388C67.5415 66.5154 67.5159 66.6415 67.4663 66.7592C67.4167 66.8769 67.344 66.9838 67.2523 67.0739C67.1606 67.164 67.0518 67.2354 66.932 67.2842C66.8122 67.3329 66.6838 67.358 66.5542 67.358H50.208V56.0459",
    stroke: "#FF5624",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M68.3586 51.4072H49.4102C48.8649 51.4072 48.4229 51.8415 48.4229 52.3772V55.043C48.4229 55.5787 48.8649 56.013 49.4102 56.013H68.3586C68.9039 56.013 69.3459 55.5787 69.3459 55.043V52.3772C69.3459 51.8415 68.9039 51.4072 68.3586 51.4072Z",
    stroke: "#FF5624",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M57.4395 51.4081V50.9392C57.4395 50.5627 57.5917 50.2016 57.8627 49.9353C58.1337 49.6691 58.5012 49.5195 58.8844 49.5195C59.2677 49.5195 59.6352 49.6691 59.9062 49.9353C60.1772 50.2016 60.3294 50.5627 60.3294 50.9392V51.4081",
    stroke: "#FF5624",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M66.4631 51.408C68.4247 49.3268 67.117 47.0464 65.1555 46.9115C63.0501 46.7894 61.0558 48.8386 60.1797 50.2967",
    stroke: "#FF5624",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M51.3004 51.408C49.3389 49.3268 50.6466 47.0464 52.6081 46.9115C54.7135 46.7894 56.7077 48.8386 57.5839 50.2967",
    stroke: "#FF5624",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8867_97188"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 46,
    fill: "white",
    transform: "translate(19 22)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBenefitEvent);
export default __webpack_public_path__ + "static/media/icon__benefit-event.0ac470d4be1efc23e8a06a7fbf3f0e5d.svg";
export { ForwardRef as ReactComponent };